import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Merges class names using tailwind-merge and clsx
 * @param inputs A list of class names to be merged
 * @returns The merged class names
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}